import ViktorClient from '@/api/clients/viktorClient/ViktorClient';
/**
 * use to send husbspot ticket suppport
 * @param data Form data to post to HubSpot ticket
 */
export function postHubspotTicket(formData: FormData) {
  return ViktorClient().post('/hubspot/ticket', formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
}
